module.exports = __webpack_public_path__ + "static/media/LG350W.72941242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LG350W.jpg
// module id = 1078
// module chunks = 0